import { render, staticRenderFns } from "./HomeCompanyIntroduction.vue?vue&type=template&id=246749fe"
import script from "./HomeCompanyIntroduction.vue?vue&type=script&lang=js"
export * from "./HomeCompanyIntroduction.vue?vue&type=script&lang=js"
import style0 from "./HomeCompanyIntroduction.vue?vue&type=style&index=0&id=246749fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports